import { render, staticRenderFns } from "./RelatorioGeral.vue?vue&type=template&id=8cfe7b7c&scoped=true"
import script from "./RelatorioGeral.vue?vue&type=script&lang=js"
export * from "./RelatorioGeral.vue?vue&type=script&lang=js"
import style0 from "./RelatorioGeral.vue?vue&type=style&index=0&id=8cfe7b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfe7b7c",
  null
  
)

export default component.exports